// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"dd12b1a7","132":"447049ca","236":"67170c14","270":"87cdb6d8","355":"5c4468da","372":"85912da2","500":"6a801a7f","579":"c9cf3228","787":"3b87ff0f","917":"5b2e560c","925":"64583f2b","964":"8fdd7201","987":"6599ec80"}[chunkId] + ".chunk.js";
};